import { GRAPHQL_ERROR_TYPES } from '@/shared/constants';
import {
  type AtsGetPublicListDepartmentsCareerSiteQueryVariables,
  useAtsGetPublicListDepartmentsCareerSiteQuery,
} from './graphql/use-get-list-departments-career-site.v5.generated';

type TUseGetListDepartmentsCareerSiteOptions = {
  skip?: boolean;
};

export const useGetListDepartmentsCareerSite = (
  variables: AtsGetPublicListDepartmentsCareerSiteQueryVariables,
  options?: TUseGetListDepartmentsCareerSiteOptions,
) => {
  const getListDepartmentsCareerSite =
    useAtsGetPublicListDepartmentsCareerSiteQuery({
      variables,
      context: {
        clientName: 'v5',
      },
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
      skip: options?.skip,
    });

  const responseType =
    getListDepartmentsCareerSite.data?.ats_recruitment
      .list_departments_career_site?.__typename;

  if (
    getListDepartmentsCareerSite.error ||
    (responseType &&
      responseType !== 'ATSListDepartmentsCareerSitePayload' &&
      GRAPHQL_ERROR_TYPES.includes(responseType))
  ) {
    const typedError =
      getListDepartmentsCareerSite.data?.ats_recruitment
        .list_departments_career_site;
    const errorMessage =
      getListDepartmentsCareerSite.error?.message ||
      (typedError && 'message' in typedError
        ? typedError.message
        : undefined) ||
      'Unknown error';

    return {
      ...getListDepartmentsCareerSite,

      error: errorMessage,
      data: null,
    };
  }
  if (
    getListDepartmentsCareerSite.data?.ats_recruitment
      .list_departments_career_site?.__typename ===
    'ATSListDepartmentsCareerSitePayload'
  ) {
    return {
      ...getListDepartmentsCareerSite,
      data: getListDepartmentsCareerSite.data?.ats_recruitment
        .list_departments_career_site,
    };
  }

  return {
    ...getListDepartmentsCareerSite,
    data: null,
    error:
      'Unexpected response structure: missing ATSListDepartmentsCareerSitePayload data',
  };
};
